import PropTypes from 'prop-types';
import { Button } from 'ypf-pas-general-ui-components';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { useWorkReportModals } from '../../../../context/WorkReportModalsContext';
import ConditionalWrapper from '../../../ConditionalWrapper/ConditionalWrapper';

const ApprovalButton = ({ ids, fetchData, selectedDate }) => {
  const { activeApproveAllModal } = useWorkReportModals();
  const fetchDataWithDefaultParams = () => fetchData();
  const selectedDateFormated = new Date(selectedDate);
  const today = new Date();
  const todayOlderThanSelectedDate = today < selectedDateFormated;

  return (
    <ConditionalWrapper
      condition={todayOlderThanSelectedDate}
      wrapper={(children) => (
        <OverlayTrigger
          delay={{
            show: 250,
            hide: 400
          }}
          overlay={
            <Tooltip id="button-aprove-all-tooltip">Linea con fecha posterior a la actual</Tooltip>
          }
          placement="left"
        >
          {children}
        </OverlayTrigger>
      )}
    >
      <div>
        <Button
          disabled={todayOlderThanSelectedDate}
          label="Aprobar Todo"
          onClick={() => activeApproveAllModal(ids, fetchDataWithDefaultParams)}
          type="submit"
          variant="primary"
        />
      </div>
    </ConditionalWrapper>
  );
};

export default ApprovalButton;

ApprovalButton.propTypes = {
  ids: PropTypes.arrayOf(PropTypes.number).isRequired,
  selectedDate: PropTypes.string.isRequired,
  fetchData: PropTypes.func
};

ApprovalButton.defaultProps = {
  fetchData: () => {
    /* { empty } */
  }
};
